export function addEllipsisOverflow(string: string, limit: number) {
  if (string.length > limit) {
    return `${string.slice(0, limit)}...`;
  }
  return string;
}

const diacriticsMap: { [state: string]: string } = {
  a: 'á|à|ã|â|À|Á|Ã|Â',
  e: 'é|è|ê|É|È|Ê',
  i: 'í|ì|î|Í|Ì|Î',
  o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
  u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
  c: 'ç|Ç',
};

export const removeDiacritics = (string: string): string => {
  let replacedString = string.toLowerCase();

  Object.keys(diacriticsMap).forEach((pattern) => {
    replacedString = replacedString.replace(
      new RegExp(diacriticsMap[pattern], 'g'),
      pattern,
    );
  });

  return replacedString;
};

export const formatStringToDiacriticsRegEx = (string: string): string => {
  let formattedString = removeDiacritics(string);

  Object.keys(diacriticsMap).forEach((pattern) => {
    formattedString = formattedString.replace(
      new RegExp(pattern, 'gi'),
      `[${pattern}|${diacriticsMap[pattern]}]`,
    );
  });

  return formattedString;
};
